import { gql } from '@apollo/client';

export const ADD_SELECTED_PERIODS_TO_INDICATOR = gql`
  mutation AddSelectedPeriodsToIndicator($input: AddSelectedPeriodsToIndicatorInput!) {
    indicator: addSelectedPeriodsToIndicator(input: $input) {
      id
    }
  }
`;
